import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Approximate centre points for each emirate.
const COORDS = {
  dubai: [25.2048, 55.2708],
  'abu-dhabi': [24.4539, 54.3773],
  sharjah: [25.3463, 55.4211],
  'ras-al-khaimah': [25.7895, 55.9432],
  fujairah: [25.1288, 56.3265],
  ajman: [25.4052, 55.5136],
  'umm-al-quwain': [25.5647, 55.5552],
};

function makePin(label) {
  return L.divIcon({
    className: 'uae-emirate-pin',
    html: `<div style="transform:translate(-50%,-100%);cursor:pointer">
      <div style="background:#1B1D21;color:#fff;font:600 12px Inter,sans-serif;padding:5px 11px;border-radius:999px;white-space:nowrap;box-shadow:0 6px 16px -4px rgba(27,29,33,.5);border:2px solid #CBA344">${label}</div>
      <div style="width:10px;height:10px;background:#1B1D21;transform:rotate(45deg);margin:-5px auto 0;border-radius:2px"></div>
    </div>`,
    iconSize: [0, 0],
  });
}

const EmiratesMap = ({ emirates }) => {
  const containerRef = useRef(null);
  const mapRef = useRef(null);
  const layerRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (mapRef.current || !containerRef.current) return;
    const map = L.map(containerRef.current, { scrollWheelZoom: false }).setView([25.0, 55.4], 7);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors',
      maxZoom: 18,
    }).addTo(map);
    layerRef.current = L.layerGroup().addTo(map);
    mapRef.current = map;
    return () => { map.remove(); mapRef.current = null; };
  }, []);

  useEffect(() => {
    const map = mapRef.current;
    const layer = layerRef.current;
    if (!map || !layer) return;
    layer.clearLayers();
    const pts = [];
    (emirates || []).forEach((e) => {
      const c = COORDS[e.slug];
      if (!c) return;
      const marker = L.marker(c, { icon: makePin(e.name) });
      marker.on('click', () => navigate(`/emirates/${e.slug}`));
      marker.addTo(layer);
      pts.push(c);
    });
    if (pts.length) map.fitBounds(L.latLngBounds(pts).pad(0.3));
    setTimeout(() => map.invalidateSize(), 100);
  }, [emirates, navigate]);

  return (
    <div
      ref={containerRef}
      className="w-full h-[460px] rounded-2xl overflow-hidden border border-[#E6D7A2] shadow-[0_18px_40px_-28px_rgba(27,29,33,0.45)] z-0"
    />
  );
};

export default EmiratesMap;
